// src/services/api.js
import axios from 'axios';
import { store } from '../store';

const api = axios.create({
  // baseURL: 'https://aeroviewbackend.dockyardsoftware.com/',
  baseURL: 'https://aeroviewbackend.dockyardsoftware.com/',
  timeout: 15000,
});

// Helper function to get authKey from various sources
const getAuthKey = () => {
  // First, try to get from localStorage (redux-persist storage)
  try {
    const persistedState = localStorage.getItem('persist:root');
    if (persistedState) {
      const parsed = JSON.parse(persistedState);
      const authState = JSON.parse(parsed.auth || '{}');
      if (authState.authKey) {
        return authState.authKey;
      }
    }
  } catch (error) {
    console.debug('Error parsing persisted auth state:', error);
  }

  // Fallback: Try redux store
  try {
    const authKey = store.getState()?.auth?.authKey;
    if (authKey) {
      return authKey;
    }
  } catch (error) {
    console.debug('Error getting auth from store:', error);
  }

  // Final fallback: Direct localStorage
  const directAuthKey = localStorage.getItem('authKey');
  if (directAuthKey) {
    return directAuthKey;
  }

  return null;
};

// Request interceptor - adds auth-key automatically
api.interceptors.request.use((config) => {
  const authKey = getAuthKey();

  if (authKey) {
    config.headers['auth-key'] = authKey;
    console.debug('Request headers set with auth-key');
  } else {
    console.warn('No authKey found for API request to', config.url);
  }

  return config;
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn('Unauthorized (401) - Auth token may be expired or invalid');
      
      // Clear invalid auth from localStorage and localStorage
      localStorage.removeItem('authKey');
      try {
        const persistedState = localStorage.getItem('persist:root');
        if (persistedState) {
          const parsed = JSON.parse(persistedState);
          const authState = JSON.parse(parsed.auth || '{}');
          authState.authKey = null;
          authState.isAuthenticated = false;
          parsed.auth = JSON.stringify(authState);
          localStorage.setItem('persist:root', JSON.stringify(parsed));
        }
      } catch (error) {
        console.debug('Error clearing persisted auth state:', error);
      }
      
      // Redirect to login
      if (window.location.pathname !== '/login') {
        console.log('Redirecting to login...');
        window.location = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;